const module = { name: 'news/articleLanding/app', exports: {} }; const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango as Fandango_context } from 'require-core';

const { context: { req: { params } } } = Fandango_context;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_debugLog as debugLog } from 'require-core';



import { fd_url_manager as links } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';



const Selectors = {
    ITEM_CONTAINER: '.content-item-container',
    MORE_BTN: '#more-button',
    WALL: '.wall',
}
function onImagesLoaded() {
    const $container = $(Selectors.WALL);
    $container.isotope({ itemSelector: Selectors.ITEM_CONTAINER });
    $(window).on('resize', $.debounce(250, () => $container.isotope()));
}
function onDone(result) {
    const $moreBtn = $(Selectors.MORE_BTN);
    if (result.done) {
        return $moreBtn.hide();
    }
    if (!result.markup) {
        debugLog.warn(module.name, 'napiHubArticleLandingPager response malformed');
        return $moreBtn.hide();
    }
    const $items = $(Selectors.ITEM_CONTAINER, result.markup);
    const $container = $(Selectors.WALL);
    $items
        .addClass('hide-item')
        .appendTo($container)
        .imagesLoaded(() => {
        $container.isotope('appended', $items);
        $items.removeClass('hide-item');
        $moreBtn
            .text($moreBtn.data('text-state-default')).removeAttr('disabled')
            .data('next-page', result.nextPage);
    });
}
function onClick() {
    const $moreBtn = $(Selectors.MORE_BTN);
    $moreBtn.text($moreBtn.data('text-state-loading')).attr('disabled', 'disabled');
    const nextPageUrl = links.napiHubArticleLandingPager({
        hub: params.hub,
        page: $moreBtn.data('next-page')
    });
    xhr.ajax({
        method: 'GET',
        url: nextPageUrl,
    })
        .done(onDone)
        .fail(() => $moreBtn.hide());
}
function run() {
    checkDependencies(module.name, debugLog);
    $(Selectors.WALL).imagesLoaded(onImagesLoaded);
    $(Selectors.MORE_BTN).on('click', onClick);
}
run();
export default module.exports;